import { FaPhone } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { socket } from "../socket/socket";
import { CALL_EVENTS } from "../socket/socketEvents";
import { resetCallState } from "../features/call/callSlice";
import CallAudioManager from "../utils/CallAudioManager";
import { useEffect } from "react";
import { getProfileImage } from "../utils/helpers";

export default function AnswerVideoCall() {
  const dispatch = useDispatch();
  const call = useSelector((state) => state.call);

  useEffect(() => {
    document.body.classList.add("hide-zoho-chat");

    return () => {
      document.body.classList.remove("hide-zoho-chat");
    };
  }, []);

  if (!call || call.status !== "incoming") return null;

  const accept = () => {
    CallAudioManager.stopAll();

    socket.emit(CALL_EVENTS.CALL_ACCEPT, {
      callId: call.callId,
    });
  };

  const reject = () => {
    CallAudioManager.stopAll();
    CallAudioManager.playEnd();

    socket.emit(CALL_EVENTS.CALL_REJECT, {
      callId: call.callId,
    });
    dispatch(resetCallState());
  };

  return (
    <div className="fixed inset-0 bg-black z-[9999] flex justify-center items-center">
      {/* WRAPPER for WEB */}
      <div
        className="
                    relative 
                    w-full h-full 
                    md:w-[40%]
                    bg-black 
                    md:overflow-hidden
                "
      >
        <VideoCallConnecting
          name={call?.remote?.name}
          country={call?.remote?.country}
          flag={call.remote?.flag}
          profileImg={getProfileImage(call?.remote?.profileImg)}
          bgImg={call?.remote?.profileImg}
        />

        <div className="absolute flex items-center gap-32 bottom-20 left-1/2 -translate-x-1/2 z-30">
          {/* END CALL */}
          <button
            onClick={reject}
            className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center shadow-lg active:scale-90 transition"
          >
            <FaPhone
              className="text-white"
              size={25}
              style={{ transform: "rotate(225deg)" }}
            />
          </button>

          {/* ACCEPT CALL */}
          <button
            onClick={accept}
            className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center shadow-lg active:scale-90 transition"
          >
            <FaPhone
              className="text-white"
              size={25}
              style={{ transform: "rotate(90deg)" }}
            />
          </button>
        </div>
      </div>
    </div>
  );
}

function VideoCallConnecting({ name, country, flag, profileImg, bgImg }) {
  return (
    <div className="relative w-full h-screen overflow-hidden bg-black text-white">
      {/* Background Blur Image */}
      <img
        src={bgImg}
        alt="background"
        className="absolute inset-0 w-full h-full object-cover opacity-60 blur-md scale-110"
      />

      {/* Dim overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Center Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 -translate-y-40">
        {/* Round Profile Image */}
        <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-white shadow-lg">
          <img
            src={profileImg}
            alt="profile"
            className="w-full h-full object-cover"
          />
        </div>

        {/* User Name */}
        <h2 className="text-xl font-semibold">{name}</h2>

        {/* Country */}
        <p className="flex items-center justify-center gap-2 text-sm opacity-80">
          <img src={flag} alt="flag" className="w-6 h-4 rounded-sm" />
          {country}
        </p>
      </div>
    </div>
  );
}
